import { useDispatch, useSelector } from 'react-redux';
import ReqFileUploadResultBoard from '../components/ReqFileUploadResultBoard';
import {
  boardState,
  BoardStatus,
  setIsProcessing,
  setStatus
} from 'common/modules/app/board';
import {
  DeviceActivateInitialState,
  getDevicesActivation,
  POST_DEVICES_ACTIVATION_RESERVE_ID,
  postDevicesActivationReserve,
  resetDevicesActivation
} from 'common/modules/domain/deviceActivate';
import { loadCookie, SasCookieKeys } from 'common/utils/cookie-utils';
import { AppState } from 'pages';
import { GlossaryState } from 'common/modules/app/glossaries';
import { Glossary } from 'common/utils/glossary';
import { endFetch } from 'common/modules/app/fetch';
import { UserInformation } from 'common/modules/domain/user';

/**
 * StoreのStateからComponentに渡すPropsへ
 */
const useStateProps = () => {
  const boardState = useSelector<AppState, boardState>(
    (state) => state.app.board
  );
  const glState = useSelector<AppState, GlossaryState>(
    (state) => state.app.glossaries
  );
  const deviceActivateState = useSelector<AppState, DeviceActivateInitialState>(
    (state) => state.domain.deviceActivate
  );
  const userState = useSelector<AppState, UserInformation>(
    (state) => state.domain.user
  );

  return {
    user: userState,
    isDisplay:
      boardState.status === BoardStatus.DEVICE_ACTIVATE_UPLOAD_RESULT_DISP,
    purchaseIdForDeviceActivation: boardState.selectedPurchaseIdForTerminal,
    glossary: Glossary.instance(glState),
    reqDataList: deviceActivateState.reqDataList,
    reserveResponse: deviceActivateState.reserveResponse
  };
};

type SelectedState = ReturnType<typeof useStateProps>;

/**
 * Actionをdispatchする関数からComponentに渡すPropsへ
 */
const useMargeProps = (state: SelectedState) => {
  const dispatch = useDispatch();
  const cookie = loadCookie();
  const _token = cookie[SasCookieKeys.KEY_TOKEN];
  const _refreshToken = cookie[SasCookieKeys.KEY_REFRESH_TOKEN];
  const _purchaseIdForDeviceActivation = state.purchaseIdForDeviceActivation;
  const _language = state.user.language;

  // 閉じるボタンの処理
  const onClickClose = () => {
    // POST_DEVICES_ACTIVATION_RESERVE_IDを未処理に変更(DryRunモードの時に処理中の状態になっているため)
    dispatch(endFetch(POST_DEVICES_ACTIVATION_RESERVE_ID));
    dispatch(setIsProcessing(false));
    // 最初に取得した有償機能アクティベート情報一覧の他、deviceActivateReducerで管理しているstateをクリア
    dispatch(resetDevicesActivation());
    // 有償ファームウェアのアクティベート一覧取得APIを実行
    dispatch(
      getDevicesActivation(
        _token,
        _refreshToken,
        _purchaseIdForDeviceActivation,
        false,
        false
      )
    );
    // 機能アクティベート管理画面を表示
    dispatch(setStatus(BoardStatus.DEVICE_ACTIVATE_DISP));
  };

  // はい(開始)ボタンの処理
  const onClickYes = () => {
    // 有償ファームウェアのアクティベート予約APIを通常モードで実行
    dispatch(
      postDevicesActivationReserve(
        _token,
        _refreshToken,
        _purchaseIdForDeviceActivation,
        state.reqDataList,
        state.glossary,
        _language,
        false,
        false
      )
    );

    // 確認ダイアログを閉じて機能アクティベート管理画面を表示(予約API実行中は機能アクティベート管理画面上でスピナーが表示される)
    dispatch(setStatus(BoardStatus.DEVICE_ACTIVATE_DISP));
  };

  return {
    onClickClose,
    onClickYes
  };
};

/**
 * リクエストファイルアップロード時の確認/エラーダイアログ全体のContainer Component
 */
export default function ContainerComponent(ownProps: { isMobile?: boolean }) {
  const _props = { ...useStateProps(), ...useMargeProps(useStateProps()) };
  return <ReqFileUploadResultBoard {...{ ..._props, ...ownProps }} />;
}
